import React, { Component } from "react";
import { Modal, Image, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import pmg_icon from "../../../assets/pmg_icon.svg";
import hierarchy_central from "../../../assets/hierarchy_central.svg";
import central_department_icon from "../../../assets/central_department_icon.svg";
import industrial_icon from "../../../assets/industrial_icon.svg";
import statepmg_icon from "../../../assets/statepmg_icon.svg";
import state_icon from "../../../assets/state_icon.svg";
import state_pmg_icon from "../../../assets/state_pmg_icon.svg";
import state_department_icon from "../../../assets/state_department_icon.svg";
import district_icon from "../../../assets/district_icon.svg";
import request from "../../../services/requestService";
import { getGroupHierarchy } from "../../../services/apiServices";
import LoaderTemplate from "../../../component/LoaderTemplate";
import { FilterLoader } from "../../../component/LoadersTemplate";
class OrganizationalChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLevel: null,
      levels: [],
      originalLevels: [],
      childrens: [],
      displayLoader: false
    };
  }
  componentDidMount() {
    const { parentsLevels } = this.props;
    console.log(parentsLevels);
    this.setState({
      // originalLevels: this.state.levels
      originalLevels: parentsLevels.parentsLevels,
      levels: parentsLevels.parentsLevels,
      childrens: parentsLevels.childrens,
      // activeLevel: parentsLevels.childrens.length == 0 ? null : parentsLevels.id
      activeLevel: parentsLevels.id
    });
  }
  handleClick = async id => {
    this.setState(prevState => ({
      activeLevel: prevState.activeLevel === id ? null : id
    }));
    this.setState({ displayLoader: true, childrens: [] });
    const response = await request(getGroupHierarchy(id));
    if (response.status) {
      this.setState({
        displayLoader: false,
        childrens: response.data.data.childrens,
        levels: response.data.data.parentsLevels
      });
    }
  };
  displayIcon = value => {
    if (value == "PMG") {
      return pmg_icon;
    } else if (value == "CENTRAL") {
      return hierarchy_central;
    } else if (value == "INDUSTRIAL" || value == "OTHER") {
      return industrial_icon;
    } else if (value == "CENTRAL_DEPARTMENT") {
      return central_department_icon;
    } else if (value == "STATE") {
      return state_icon;
    } else if (value == "STATE_DEPARTMENT") {
      return state_department_icon;
    } else if (value == "DISTRICT") {
      return district_icon;
    } else if (value == "STATE_PMG") {
      return state_pmg_icon;
    }
  };
  width = value => {
    if (
      value == "STATE_DEPARTMENT" ||
      value == "DISTRICT" ||
      value == "STATE_PMG"
    ) {
      return "50px";
    }
  };
  handleClickChild = async (clickedItem, id) => {
    this.setState({ displayLoader: true, childrens: [] });
    const newObj = {
      id: id,
      title: clickedItem.name,
      subtitle: clickedItem.subtitle,
      category: clickedItem.category,
      childCount: clickedItem.childCount
    };

    this.setState(prevState => {
      const updatedLevels = [...prevState.levels];

      // Check if already exists
      const alreadyExists = updatedLevels.some(level => level.id === newObj.id);

      if (!alreadyExists) {
        updatedLevels.push(newObj); // ✅ add to last
      }

      return {
        levels: updatedLevels,
        activeLevel: newObj.id
      };
    });
    const response = await request(getGroupHierarchy(id));
    if (response.status) {
      this.setState({
        displayLoader: false,
        childrens: response.data.data.childrens
      });
    }
  };
  handleClose = levelTitle => {
    console.log(levelTitle);
    this.setState(
      prevState => {
        const titlesArray = this.state.originalLevels.map(item => item.title);
        console.log(titlesArray);
        if (titlesArray.includes(levelTitle)) {
          return {
            activeLevel: null,
            levels: [...prevState.originalLevels] // reset to original
          };
        }

        const index = prevState.levels.findIndex(
          item => item.title === levelTitle
        );

        if (index === -1) {
          return { activeLevel: null };
        }

        return {
          activeLevel: null,
          levels: prevState.levels.slice(0, index + 1)
        };
      },
      () => {
        console.log(this.state.levels);
      }
    );
  };
  // handleClose = (levelTitle) => {
  //   console.log(levelTitle)
  //   this.setState(prevState => {
  //     const index = prevState.levels.findIndex(
  //       item => item.title === levelTitle
  //     );

  //     if (index === -1) {
  //       return { activeLevel: null };
  //     }

  //     return {
  //       activeLevel: null,
  //       levels: prevState.levels.slice(0, index + 1)
  //     };
  //   });
  // };
  onClose = () => {
    this.props.onClick();
  };
  render() {
    const { activeLevel, levels, childrens, displayLoader } = this.state;
    const { isModalDisplay } = this.props;
    return (
      <Modal
        show={isModalDisplay}
        onHide={this.onClose}
        dialogClassName="organizational-chart-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Organizational Chart</h2>
            <p>Hierarchy-wise reporting structure</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="chart-wrapper">
            {levels.map((item, index) => {
              const activeIndex = levels.findIndex(
                level => level.id === activeLevel
              );

              if (activeLevel && index > activeIndex) return null;

              return (
                <React.Fragment key={item.id}>
                  <div
                    className={`organizational-card ${
                      activeLevel === item.id ? "active" : ""
                    }`}
                    style={{
                      cursor:
                        item.childCount == 0 || activeLevel === item.id
                          ? "default"
                          : "pointer"
                    }}
                    onClick={
                      activeLevel === item.id
                        ? undefined
                        : item.childCount
                        ? () => this.handleClick(item.id)
                        : undefined
                    }
                  >
                    <div className="icon">
                      <img
                        src={this.displayIcon(item.category)}
                        style={{ width: this.width(item.category) }}
                      />
                    </div>
                    <div>
                      <h3>{item.title}</h3>
                      <span>{item.subtitle}</span>
                    </div>
                  </div>

                  {(index !== levels.length - 1 || activeLevel === item.id) && (
                    <div
                      className={`connector ${
                        activeLevel === item.id ? "dotted" : ""
                      }`}
                    />
                  )}

                  {activeLevel === item.id && childrens && (
                    <div className="child-wrapper">
                      <div className="child-header">
                        <div className="child-title-heading">
                          Organization(s) under <span>{item.title}</span>
                          {childrens.length > 0 && ` (${childrens.length})`}
                        </div>
                      </div>
                      {displayLoader ? (
                        <div className="skeleton-container">
                          <div className="skeleton-card">
                            <div className="skeleton-title" />
                            <div className="skeleton-row">
                              <div className="skeleton-text" />
                              <div className="skeleton-btn" />
                            </div>
                            <div className="skeleton-row">
                              <div className="skeleton-text short" />
                              <div className="skeleton-btn" />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="child-container">
                          {childrens && childrens.length > 0 ? (
                            childrens.map((child, i) => (
                              <div
                                key={i}
                                className="child-card"
                                onClick={() =>
                                  this.handleClickChild(child, child.id)
                                }
                              >
                                <div className="child-title">{child.name}</div>

                                {child.subtitle && (
                                  <div className="child-subtitle">
                                    {child.subtitle}
                                  </div>
                                )}
                              </div>
                            ))
                          ) : (
                            <div>
                              <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                              <h3 className="no-data-found">
                                No Organization(s) Found
                              </h3>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default OrganizationalChart;
